module.exports = __webpack_public_path__ + "img/Combinationphoto2.280795f4.jpg";